import React from 'react';

const WebSockets = () => {
    console.log('websockettome');
    return <></>
};

export default WebSockets;
